$(document).ready(function () {

    $('.search-filter-checkbox input[type=checkbox]').on('change', function(e) {
        ajax_chalet_search({'paged': 1});
    });

    $('#search_filter_orderby').on('select2:select', function(e) {
        ajax_chalet_search({'paged': 1});
    });
    $('#filterInputDate').on('change', function(e) {
        ajax_chalet_search({'paged': 1});
    });

    /**
     * Intercept the pagination links and load them via AJAX instead
     */
    $(document).on('click', '#ajaxLoad .paging a', function(e) {
        e.preventDefault();

        const _urlSplit = e.currentTarget.href.split(/[?#]/);
        let _urlQuery = Object.fromEntries(new URLSearchParams(_urlSplit[1]));


        // If we have a pageid=x arg, use that, otherwise look for /page/x/ in the URL
        if (_urlQuery.hasOwnProperty('pageid')) {

            _urlQuery.paged = _urlQuery.pageid;

        } else {
            const _pageRegex = /\/page\/([0-9]+)/;
            const _pageMatch = _pageRegex.exec(_urlSplit[0]);
            const _page = (null != _pageMatch && 'undefined' !== typeof _pageMatch[1]) ? _pageMatch[1] : 1;

            _urlQuery.paged = _page;
        }

    
        ajax_chalet_search(_urlQuery);
    });


    if (chalet_search_params.autoload && $('#ajaxLoad').length) {
        ajax_chalet_search({}, true);
    }

});


window.ajax_chalet_results_are_loading = function(_initial = false)
{
    const $ajaxLoad = jQuery('#ajaxLoad');
    $ajaxLoad.addClass('loading');

    jQuery('.search-results-count').html('Loading...');
    jQuery('#searchFilters input, #searchFilters select').prop('disabled', true);

    const $searchResultsScrollTop = jQuery('body.search.search-results');
    const $searchScrollTop = jQuery('#searchScrollTop');

    if (chalet_search_params.scroll && !_initial) {

        if ($searchScrollTop.length) {
            jQuery('html, body').animate({
                scrollTop: $searchScrollTop.offset().top - ($searchResultsScrollTop.length ? 275 : 200)
            }, 500);
        } else {
            jQuery('html, body').animate({
                scrollTop: jQuery('body').offset().top
            }, 500);
        }
    }
}


window.ajax_chalet_results_finished_loading = function(response)
{
    const $ajaxLoad = jQuery('#ajaxLoad');

    let _count = 0;
    
    if (response.data.hasOwnProperty('count')) {
        _count = response.data.count;
    }

    $ajaxLoad
        .html(response.data.html)
        .removeClass('loading');

    $('.search-results-count').html('Showing <span>' + _count + '</span> properties');
    $('#searchFilters input, #searchFilters select').prop('disabled', false);
}


window.ajax_chalet_search = function(_extraArgs = {}, _initial = false)
{
    const _filter_accessor = '#searchFilters input[type="checkbox"][name="additional_filters[]"]:checked, #searchFilters input[type="hidden"][name="additional_filters[]"]';
    const _location_accessor = '#searchFilters input[type="hidden"][name="resort_locations[]"]';
    const _orderby_accessor = 'search_filter_orderby';
    const _date_accessor = '#filterInputDate';

    ajax_chalet_results_are_loading(_initial);

    const _filters = Array.from(document.querySelectorAll(_filter_accessor), e => e.value);
    const _locations = Array.from(document.querySelectorAll(_location_accessor), e => e.value);
    
    let _orderby;
    const _orderby_elem = document.getElementById(_orderby_accessor);

    if ('undefined' != typeof(_orderby_elem) && null != _orderby_elem) {
        _orderby = _orderby_elem.value;
    }

    let _date;
    const _date_elem = document.getElementById('filterInputDate');

    if ('undefined' != typeof(_date_elem) && null != _date_elem) {
        _date = _date_elem.value;
    }

    

    const _defaults = {
        'action': chalet_search_params.action,
        's': chalet_search_params.s,
        'top_filter_form': 1,
        'paged': chalet_search_params.paged,
        'check_in_date': (null != _date) ? _date : chalet_search_params.check_in_date,
        'orderby': _orderby,
        'chalet_type': chalet_search_params.chalet_type,
        'additional_filters': _filters,
        'resort_locations': _locations,
        'number_guests': chalet_search_params.number_guests,

        'is_collection': chalet_search_params.is_collection,
        'is_special_offers': chalet_search_params.is_special_offers,

        'posts_per_page': chalet_search_params.posts_per_page,
    };

    let _args = jQuery.extend({}, _defaults, _extraArgs);


    // Submit AJAX request
    jQuery.post(chalet_search_params.ajaxurl, _args).done(ajax_chalet_results_finished_loading);
}